/* istanbul ignore file */
import { GLOBAL } from '@lumapps/translations';

export const USER_DIRECTORY_REACT = 'user-directory-react';
export const USER_PROFILE_REACT = 'user-profile-react';
export const USERS_DIRECTORY_MAX_RESULTS = '12';

export const MIN_ITEM_WIDTH = 248;
export const BLOCK_SKELETON_HEIGHT = 296;
export const FIELDS_KEYS = {
    first_name: GLOBAL.FIRST_NAME,
    last_name: GLOBAL.LAST_NAME,
    group: GLOBAL.GROUP,
};

export enum CUSTOM_FILTER_TYPE {
    DATE = 'date',
    EMAIL = 'email',
    GROUP = 'group',
    METADATA = 'metadata',
    USER = 'user',
}

export const CUSTOM_FILTER_RENDERER = {
    [CUSTOM_FILTER_TYPE.DATE]: `UD-custom-filter-${CUSTOM_FILTER_TYPE.DATE}`,
    [CUSTOM_FILTER_TYPE.EMAIL]: `UD-custom-filter-${CUSTOM_FILTER_TYPE.EMAIL}`,
    [CUSTOM_FILTER_TYPE.GROUP]: `UD-custom-filter-${CUSTOM_FILTER_TYPE.GROUP}`,
    [CUSTOM_FILTER_TYPE.METADATA]: `UD-custom-filter-${CUSTOM_FILTER_TYPE.METADATA}`,
    [CUSTOM_FILTER_TYPE.USER]: `UD-custom-filter-${CUSTOM_FILTER_TYPE.USER}`,
};

export const DEFAULT_FILTERS_FIELDS = ['first_name', 'last_name', 'groups'];
export const KEYS_TO_SKIP = new Set(['first_name', 'last_name', 'groups']);

/* List of rest default types */
export enum FILTER_TYPES_DEFAULT {
    LINK = 'LINK',
    LONG_TEXT = 'LONG_TEXT',
    INT = 'INT',
    FLOAT = 'FLOAT',
    MOBILE_PHONE = 'MOBILE_PHONE',
    PHONE = 'PHONE',
}

export const RANGE_SKELETON_BLOCK_SIZE = 8;

export const USER_LIST_MAX_RESULTS = '12';
